import { EmployeeDto } from "./EmployeeDto";

export class Employee {
    public employeeModel: EmployeeDto;

    public firstName: string | undefined = '';
    public lastName: string | undefined = '';
    public phoneNumber: string | undefined = '';
    public email: string | undefined = '';

    constructor(employee?: EmployeeDto) {
        this.employeeModel = employee ?? new EmployeeDto();
        this.firstName = this.employeeModel.firstName;
        this.lastName = this.employeeModel.lastName;
        this.phoneNumber = this.employeeModel.phoneNumber;
        this.email = this.employeeModel.email;
    }

    public Reset(){
        this.firstName = this.employeeModel.firstName;
        this.lastName = this.employeeModel.lastName;
        this.phoneNumber = this.employeeModel.phoneNumber;
        this.email = this.employeeModel.email;
    }

    get HasChanges() {
        return this.firstName !== this.employeeModel.firstName
        || this.lastName !== this.employeeModel.lastName
        || this.phoneNumber !== this.employeeModel.phoneNumber
        || this.email !== this.employeeModel.email;
    }

    get FullName(){
        let firstName = this.firstName !== undefined && this.firstName !== '' ? this.firstName : '';
        let lastName = this.lastName !== undefined && this.lastName !== '' ? this.lastName : '';

        if(firstName !== '' && lastName !== ''){
            return lastName + ", " + firstName;
        }

        return firstName || lastName;
    }

    public GetModel(){
        let model = new EmployeeDto();

        model.id = this.employeeModel.id;
        model.firstName = this.firstName;
        model.lastName = this.lastName;
        model.email = this.email;
        model.phoneNumber = this.phoneNumber;

        return model;
    }

    public SetValues(employee: EmployeeDto){
        this.employeeModel = employee ?? new EmployeeDto();
        this.firstName = employee.firstName;
        this.lastName = employee.lastName;
        this.phoneNumber = employee.phoneNumber;
        this.email = employee.email;
    }
}
